// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1wCZc","upload":"Small_upload__EHk5K","imageWrap":"Small_imageWrap__2pvmz","removeBtn":"Small_removeBtn__1-WTv"};